import React, { useContext, useState } from "react";
import ModalContext from "../../../Contexts/openModal";
import "../../../styles/components/Slices/heroMonet.scss";
import CustomButton from "../../CustomButton";
import LogoMarquee from "../../LogoMarquee";
import graphicPoster from "../../../assets/new-home-page/bg_graphics_poster.webp";
import bg_video from "../../../assets/new-home-page/bg_graphic_flow.webm";
import VideoComponent from "../../VideoComponent";
import SingleEmailForm2 from "../../Pieces/SingleEmailForm2";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-hot-toast";
import { RUBRIC_EVALUATION } from "../../../constants";
import axios from "axios";
import xss from "xss";

const downloadFile = async () => {
  return axios({
    url: RUBRIC_EVALUATION,
    responseType: "blob",
    method: "GET",
  })
    .then((response) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Rubric Evaluation - A Comprehensive Framework for Generative AI Assessment.pdf`,
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    })
    .catch((err) => {
      console.error("Error while file download:", err);
    });
};

const HeroMonet = ({ slice, location }) => {
  const aiAgentPage = location?.pathname == "/data-agents/";
  const isDesktop = useMediaQuery({ maxWidth: 1234, minWidth: 1023 });
  const isMobile = useMediaQuery({ maxWidth: 520 });
  const { toggleModal, setEmail } = useContext(ModalContext);
  const isAlignCenter = slice?.primary?.heading_section_position === "Center";
  const isEmpty = slice?.primary?.trusted_by_logo_alignment === "empty";

  const RubricPage_2 =
    location?.pathname ===
    "/rubric-evaluation-generative-ai-assessment-framework/";
  const leftBottom =
    slice?.primary?.trusted_by_logo_alignment === "left bottom";
  const rightBottom =
    slice?.primary?.trusted_by_logo_alignment === "right bottom";
  const GrayText = slice?.primary?.strong_text_gray === true;
  const logo_marque_data = {
    items: slice.items.map((x) => ({
      brand_image: { ...x.trusted_by_logo },
    })),
  };
  const logosPresent =
    logo_marque_data?.items?.filter((item) => item?.brand_image?.url).length >
    0;
  const scrollToSection = (url) => {
    if (url && url?.charAt(0) === "#") {
      const sectionId = url.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - 90;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    } else toggleModal();
  };
  const isUrl =
    slice?.primary?.cta_link?.url &&
    slice?.primary?.cta_link?.url?.charAt(0) !== "#";
  const emptySlice = !!(
    slice?.primary?.title?.html || slice?.primary?.description?.text
  );
  const FormMonetPages =
    location?.pathname == "/contact-us/" ||
    location?.pathname == "/meet-encord-at-cvpr/" ||
    location?.pathname == "/";
  const HomePage = location?.pathname == "/";
  const isDark = slice?.primary?.theme === "dark";
  const topSpacing = slice?.primary?.top_spacing;
  const bottomSpacing = slice?.primary?.bottom_spacing;
  const [downloading, setDownloading] = useState(false);
  const handleDownload = async () => {
    setDownloading(true);
    toast.success("Your download has started!");
    try {
      await downloadFile();
    } catch (err) {
      console.error("Download failed", err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      {emptySlice && (
        <article className={`relative ${isDark && "bg-purple-2300"}`}>
          {slice?.primary?.background_video?.url && (
            <video
              autoPlay
              muted
              loop
              playsInline
              className="absolute inset-0 w-full h-full object-cover z-[-1]"
            >
              <source
                src={slice?.primary?.background_video?.url}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          )}

          {(location?.pathname?.includes("/contact-us/") ||
            location?.pathname?.includes("/press/")) &&
            !isMobile && (
              <VideoComponent
                autoPlay
                poster={graphicPoster}
                className="absolute left-0 right-0 z-0 [mix-blend-mode:darken] top-24 lg:top-0 sm:top-16"
              >
                <source
                  className="row-start-1 row-end-4"
                  src={bg_video}
                  type="video/webm"
                />
              </VideoComponent>
            )}
          {slice?.primary?.background_video?.url && (
            <video
              autoPlay
              muted
              loop
              playsInline
              className="absolute inset-0 w-full h-full object-cover z-[-1]"
            >
              <source
                src={slice?.primary?.background_video?.url}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          )}
          {slice?.primary?.background_image?.url && (
            <img
              className="absolute inset-0 w-full h-full object-cover z-[-1]"
              src={slice?.primary?.background_image?.url}
            />
          )}
          <section className="relative px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl">
            <div
              className={`flex flex-col mt-auto flex-1 gap-3 mx-auto lg:mx-11 ${topSpacing === "80" ? "sm:pt-20 pt-8" : topSpacing === "40" ? "sm:pt-10 pt-8" : topSpacing === "0" ? "pt-0" : "pt-8 lg:pt-20"}  ${bottomSpacing === "80" ? "sm:pb-20 pb-8" : bottomSpacing === "40" ? "sm:pb-10 pb-8" : bottomSpacing === "0" ? "pb-0" : "pb-8 lg:pb-20"} ${isAlignCenter && HomePage ? "lg:!py-40" : ""} ${isAlignCenter && "lg:py-12"}`}
            >
              {slice?.primary?.caption_title?.text && (
                <p
                  className={`text-xs font-mono sm:text-base font-medium leading-4 sm:leading-6 uppercase tracking-widest_1 ${slice?.primary?.background_video?.url && "text-white"}  ${isDark && HomePage ? "text-gray-1200" : isDark ? "text-purple-350" : "text-purple-1500"} ${HomePage && isDark && "mt-28"} ${HomePage && slice?.primary?.background_video?.url && "mt-28"} ${isAlignCenter && "text-center"}`}
                >
                  {slice?.primary?.caption_title?.text}
                </p>
              )}
              <div
                className={`flex flex-col ${slice?.primary?.description?.text ? "gap-4" : ""} ${HomePage && isDark && "mb-28"} ${HomePage && slice?.primary?.background_video?.url && "mb-28"} ${isAlignCenter ? "lg:flex-col justify-center items-center" : "lg:flex-row lg:gap-16"}`}
              >
                <div
                  className={`${GrayText ? "lg:max-w-[570px] " : location.pathname === "/about-us/" ? "max-w-full" : location.pathname === "/careers/" ? "max-w-full " : FormMonetPages ? " lg:max-w-full sm:max-w-[580px]" : "max-w-[648px]"}  overflow-hidden flex-1 ${isAlignCenter && "flex flex-col justify-center items-center"}`}
                >
                  {slice?.primary?.title?.html && (
                    <>
                      <div
                        role="heading"
                        aria-level="2"
                        className={` ${isDark ? "text-gray-1200" : slice?.primary?.background_video?.url ? "text-gray-2200 color_style_video" : "text-gray-2700"} ${isDark && HomePage && "lg:!-tracking-[1.92px] lg:!leading-[54px]"} text-3.25xl sm:text-4.5xl font-manrope leading-[45px] sm:leading-[60px] lg::leading-12 ${
                          isEmpty && !isAlignCenter && HomePage
                            ? "font-medium"
                            : "font-medium"
                        } tracking-[-1.8px] sm:tracking-tightest_4 ${isDark ? "color_style_dark" : GrayText ? "strong-text-homepage" : HomePage ? "color_style-homepage" : "color_style"}  ${isAlignCenter ? "text-center sm:pb-2" : "lg:pb-5 "}`}
                        dangerouslySetInnerHTML={{
                          __html: xss(
                            isMobile
                              ? slice?.primary?.title?.html?.replace(
                                  /(faster)<br\s*\/?>/i,
                                  "faster ",
                                )
                              : slice?.primary?.title?.html || "",
                          ),
                        }}
                      />

                      {isEmpty &&
                        !isAlignCenter &&
                        HomePage &&
                        !slice?.primary?.show_cta &&
                        slice?.primary?.cta_text?.text && (
                          <div className="flex mt-5">
                            <SingleEmailForm2
                              openModal={toggleModal}
                              setEmail={setEmail}
                              formHsClass={slice?.primary?.hs_class?.text}
                              formId={slice?.primary?.hs_id?.text}
                              buttonText={
                                isDesktop && aiAgentPage
                                  ? "Integrate"
                                  : slice?.primary?.cta_text?.text
                              }
                            />
                          </div>
                        )}
                      {isEmpty &&
                        !isAlignCenter &&
                        HomePage &&
                        slice?.primary?.show_cta &&
                        slice?.primary?.cta_text?.text && (
                          <div className="flex">
                            <CustomButton
                              link={isUrl && slice?.primary?.cta_link?.url}
                              onClick={() => {
                                if (RubricPage_2) {
                                  handleDownload();
                                } else if (slice?.primary?.cta_link?.url) {
                                  scrollToSection(
                                    slice?.primary?.cta_link?.url,
                                  );
                                } else {
                                  toggleModal();
                                }
                              }}
                              text={slice?.primary?.cta_text?.text}
                              buttonClass={`bg-purple-1500 text-white hover:bg-[#5E24FF] mt-5 lg:mt-0 block`}
                            />
                          </div>
                        )}
                    </>
                  )}
                  {leftBottom && !isEmpty && logosPresent && !isAlignCenter && (
                    <section className="max-w-[400px] xs:max-w-[648px] marquee_padding_desktop hidden lg:block">
                      {slice?.primary?.show_logo_caption_title && (
                        <p className="pt-8 pb-5 text-xs font-semibold text-gray-600 uppercase font-manrope tracking-widest_1">
                          Trusted by pioneering AI Teams
                        </p>
                      )}
                      <LogoMarquee
                        logoArray={logo_marque_data}
                        logoBackground=""
                      />
                    </section>
                  )}
                  {slice?.primary.show_cta ? (
                    <>
                      {rightBottom && !isEmpty && !isAlignCenter && (
                        <CustomButton
                          link={isUrl && slice?.primary?.cta_link?.url}
                          onClick={() => {
                            if (RubricPage_2) {
                              handleDownload();
                            } else if (slice?.primary?.cta_link?.url) {
                              scrollToSection(slice?.primary?.cta_link?.url);
                            } else {
                              toggleModal();
                            }
                          }}
                          text={slice?.primary?.cta_text?.text}
                          buttonClass={`bg-purple-1500 text-white hover:bg-[#5E24FF] mt-5 hidden lg:block`}
                        />
                      )}
                    </>
                  ) : slice?.primary.show_email_cta ? (
                    <>
                      {rightBottom && !isEmpty && !isAlignCenter && (
                        <div className="flex mt-5">
                          <SingleEmailForm2
                            openModal={toggleModal}
                            setEmail={setEmail}
                            formHsClass={slice?.primary?.hs_class?.text}
                            formId={slice?.primary?.hs_id?.text}
                            buttonText={slice?.primary?.cta_text?.text}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={`flex-[0.5] overflow-hidden ${isAlignCenter && "flex flex-col justify-center items-center"}`}
                >
                  {slice?.primary?.description?.text && (
                    <div
                      className={`text-base sm:text-lg font-normal leading-7 text-gray-600 lg:max-w-[965px] font-inter tracking-tight_1 ${isAlignCenter && "text-center"}`}
                      dangerouslySetInnerHTML={{
                        __html: xss(slice?.primary?.description?.text),
                      }}
                    />
                  )}
                  {rightBottom &&
                    !isEmpty &&
                    logosPresent &&
                    !isAlignCenter && (
                      <section className="max-w-[400px] xs:max-w-[556px] hidden lg:block">
                        {slice?.primary?.show_logo_caption_title && (
                          <p className="pt-8 pb-5 text-xs font-semibold text-gray-600 uppercase font-manrope tracking-widest_1">
                            Trusted by pioneering AI Teams
                          </p>
                        )}
                        <LogoMarquee
                          logoArray={logo_marque_data}
                          logoBackground=""
                        />
                      </section>
                    )}
                  {slice?.primary.show_cta ? (
                    <>
                      {leftBottom && !isEmpty && (
                        <CustomButton
                          link={isUrl && slice?.primary?.cta_link?.url}
                          onClick={() => {
                            if (RubricPage_2) {
                              handleDownload();
                            } else if (slice?.primary?.cta_link?.url) {
                              scrollToSection(slice?.primary?.cta_link?.url);
                            } else {
                              toggleModal();
                            }
                          }}
                          text={slice?.primary?.cta_text?.text}
                          buttonClass={`bg-purple-1500 text-white hover:bg-[#5E24FF] mt-5 ${isAlignCenter && "mb-8"}`}
                          disabled={downloading}
                        />
                      )}
                      {rightBottom && !isEmpty && (
                        <CustomButton
                          link={isUrl && slice?.primary?.cta_link?.url}
                          onClick={() => {
                            if (RubricPage_2) {
                              handleDownload();
                            } else if (slice?.primary?.cta_link?.url) {
                              scrollToSection(slice?.primary?.cta_link?.url);
                            } else {
                              toggleModal();
                            }
                          }}
                          text={slice?.primary?.cta_text?.text}
                          buttonClass={`bg-purple-1500 text-white hover:bg-[#5E24FF] mt-5 mb-8 block  ${!isAlignCenter && "lg:hidden"}`}
                          disabled={downloading}
                        />
                      )}
                    </>
                  ) : slice?.primary.show_email_cta ? (
                    <>
                      {leftBottom && !isEmpty && (
                        <div className="flex mt-5">
                          <SingleEmailForm2
                            openModal={toggleModal}
                            setEmail={setEmail}
                            formHsClass={slice?.primary?.hs_class?.text}
                            formId={slice?.primary?.hs_id?.text}
                            buttonText={slice?.primary?.cta_text?.text}
                          />
                        </div>
                      )}
                      {rightBottom && !isEmpty && (
                        <div className="flex mt-5">
                          <SingleEmailForm2
                            openModal={toggleModal}
                            setEmail={setEmail}
                            formHsClass={slice?.primary?.hs_class?.text}
                            formId={slice?.primary?.hs_id?.text}
                            buttonText={slice?.primary?.cta_text?.text}
                          />
                        </div>
                      )}
                      {isEmpty && !isAlignCenter && !HomePage && (
                        <div className="flex mt-5">
                          <SingleEmailForm2
                            openModal={toggleModal}
                            setEmail={setEmail}
                            formHsClass={slice?.primary?.hs_class?.text}
                            formId={slice?.primary?.hs_id?.text}
                            buttonText={
                              isDesktop && aiAgentPage
                                ? "Integrate"
                                : slice?.primary?.cta_text?.text
                            }
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {!isEmpty && logosPresent && (
                    <section
                      className={`max-w-[400px] xs:max-w-[648px]  ${isAlignCenter ? " lg:max-w-4xl marquee_padding_desktop" : "lg:hidden marquee_padding"}`}
                    >
                      {slice?.primary?.show_logo_caption_title && (
                        <p className="pt-8 text-xs font-semibold text-gray-600 uppercase font-manrope tracking-widest_1">
                          Trusted by pioneering AI Teams
                        </p>
                      )}
                      <LogoMarquee logoArray={logo_marque_data} />
                    </section>
                  )}
                  {slice?.primary.show_cta ? (
                    <>
                      {isAlignCenter && isEmpty && (
                        <CustomButton
                          link={isUrl && slice?.primary?.cta_link?.url}
                          onClick={() => {
                            if (RubricPage_2) {
                              handleDownload();
                            } else if (slice?.primary?.cta_link?.url) {
                              scrollToSection(slice?.primary?.cta_link?.url);
                            } else {
                              toggleModal();
                            }
                          }}
                          text={slice?.primary?.cta_text?.text}
                          buttonClass={`bg-purple-1500 text-white hover:bg-[#5E24FF] mt-5 `}
                          disabled={downloading}
                        />
                      )}
                    </>
                  ) : slice?.primary.show_email_cta ? (
                    <>
                      {isAlignCenter && isEmpty && (
                        <div className="flex mt-5">
                          <SingleEmailForm2
                            openModal={toggleModal}
                            setEmail={setEmail}
                            formHsClass={slice?.primary?.hs_class?.text}
                            formId={slice?.primary?.hs_id?.text}
                            buttonText={slice?.primary?.cta_text?.text}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </section>
        </article>
      )}
    </>
  );
};

export default HeroMonet;
